import { AuthFlow, User } from "types/users";

export type DetectorManagementOpenModal = "new-onboarding" | "migration" | null;

export function getDetectorManagementOpenModal(user: User): DetectorManagementOpenModal {
  if (user.auth_flow === AuthFlow.FUSIONAUTH) {
    if (!user.userprofile.detector_management_onboarded) {
      return "new-onboarding";
    }
  } else if (user.auth_flow === AuthFlow.COGNITO && user.enable_idp_migration) {
    return "migration";
  }

  return null;
}
